// Pollyfill used by apollo-client:
// https://github.com/apollographql/apollo-client/blob/b0da267d24d8713987e9ff8d2240c5c7ed94eb94/src/utilities/observables/Observable.ts#L10'
// this package modifies global namespace
// to control order of execution
// include our version at the top of the App
import "symbol-observable";

import "./polyfills.less";

(globalThis as unknown as { regeneratorRuntime?: unknown }).regeneratorRuntime = undefined;
window.global = globalThis;
